import { __decorate } from "tslib";
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import ActionButton from '@/components/action_button/Index.vue';
import BaseSearchInput from '@/components/v2/BaseSearchInput';
import moment from 'moment';
import { debounce } from 'lodash';
let ComponentName = class ComponentName extends Mixins(ViewportSizeMixin, RouterParamsAppMixin) {
    constructor() {
        super(...arguments);
        this.localSelectedNotification = {};
        this.search = '';
        // private mounted() {
        //   this.localSelectedNotification = this.selectedNotification;
        // }
    }
    onSelectedNotificationChanged() {
        this.localSelectedNotification = this.selectedNotification;
    }
    handleScroll(event) {
        const list = event.target;
        const { scrollHeight, scrollTop, clientHeight } = list;
        if (scrollTop + clientHeight >= scrollHeight - 50) {
            this.$emit('load-more');
        }
    }
    handleItemClick(notification) {
        this.localSelectedNotification = notification;
        this.$emit('update-preview-data', notification);
        // const { uuid, inboxPlatformOrigin, baseUuid, photo } = item;
        // const selectedItem = { uuid, inboxPlatformOrigin, baseUuid, photo };
        // this.$store.commit('setSelectedRecipient', selectedItem);
        // this.updateRecipientReadStatus(item.uuid);
        // this.$emit('showMessage');
    }
    onAddNotification() {
        this.$emit('addNotification');
    }
    notificationTypeDisplay(text) {
        return text.split('_').join(' ');
    }
    humanReadableDate(date) {
        return moment(date).format('MM/DD/YY');
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], ComponentName.prototype, "disabled", void 0);
__decorate([
    Prop({ type: Array, required: true })
], ComponentName.prototype, "notifications", void 0);
__decorate([
    Prop({ type: Object, required: true })
], ComponentName.prototype, "selectedNotification", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ComponentName.prototype, "isNotificationLoading", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ComponentName.prototype, "isFetchMore", void 0);
__decorate([
    Watch('selectedNotification')
], ComponentName.prototype, "onSelectedNotificationChanged", null);
ComponentName = __decorate([
    Component({
        components: {
            ActionButton,
            BaseSearchInput,
        },
        apollo: {
        // Your component apollo queries here
        },
        methods: {
            debounceSearch: debounce(function () {
                this.$emit('search', this.search);
            }, 1000),
        },
    })
], ComponentName);
export default ComponentName;
